var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"textbox",style:({zIndex: _vm.zIndex})},[_c('div',{staticClass:"textbox-container",style:(_vm.textStyle),attrs:{"contenteditable":"true","id":"textbox"},domProps:{"innerHTML":_vm._s(_vm.text)},on:{"cut":function($event){$event.stopPropagation();},"blur":function($event){return _vm.updateTextbox()}}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05b37226","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/textbox.vue
// module id = null
// module chunks = 